import React from "react";
import ReactDOM from "react-dom/client";
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Outlet,
// } from "react-router-dom";

import { HashRouter as Router, Routes, Route } from "react-router-dom";

import App from "./App";
import Dashboard from "./Dashboard";
import Dash from "./Dash";
import Outlets from "./Outlets";
import reportWebVitals from "./reportWebVitals";
import "leaflet/dist/leaflet.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/dash" element={<Dash />} />
      <Route path="/outlets" element={<Outlets />} />
    </Routes>
  </Router>
);

// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
